module.exports = __webpack_public_path__ + "static/media/logo-fit-negativo.0ada8b55.svg";